{"phone":{"max":"671px"},"tab-port":{"min":"672px","max":"951px"},"tab-land":{"min":"952px","max":"1239px"},"desktop":{"min":"1240px"}}